// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__3wDXv","heroContent":"styles_heroContent__MANGL","lines":"styles_lines__0+fZC","tagLine":"styles_tagLine__t+Ebz"};